<template>
  <div :class="$options.name">
    <v-card>
      <v-card-text>
        <p>
          В данной области производится надстройка над механизмами отображения слоёв.
          Возможно указать слои и события, которые будут отображаться на карте при
          выборе произвольной области пользователем на карте.
        </p>

        <layers-select
          v-model="form.layers"
          :data="data.settings.layers"
          :items-list="layersList"
        />
      </v-card-text>

      <v-card-actions>
        <div class="d-flex flex-grow-1" />
        <v-btn :loading="isLoading" color="primary" @click="onSave">Сохранить настройки</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import get from 'lodash/get';
import LayersSelect from '@/components/page/layers/layers-select';

const createDefaultForm = () => ({
  limit: null,
  layers: [],
});

export default {
  name: 'geo-analysis-settings-view',
  asyncData({ store }) {
    const actions = [
      store.dispatch('settings/getGeoAnalysisSettings'),
      store.dispatch('layer-objects/getFullList'),
    ];

    return Promise.all(actions);
  },
  components: { LayersSelect },
  data: () => ({
    form: createDefaultForm(),
    isLoading: false,
    data: null,
  }),
  computed: {
    ...mapState('layer-objects', {
      layersList: 'fullList',
    }),
    ...mapState('settings', { single: 'geoAnalysisSingle' }),
  },
  created() {
    this.data = {
      ...this.form,
      settings: {
        layers: get(this.single.settings, 'layers', []).map(_ => ({ id: _ })),
        events: get(this.single.settings, 'events', []).map(_ => ({ id: _ })),
      },
    };

    if (get(this.single, 'settings')) {
      const layers = get(this.single.settings, 'layers', []);

      this.form = {
        ...this.form,
        layers: layers.filter(Boolean).map(_ => ({ id: _ })),
      };
    }
  },
  methods: {
    ...mapActions('settings', ['saveGeoAnalysisSettings']),

    ...mapActions(['showNotify']),

    async onSave() {
      this.isLoading = true;
      const data = {
        id: get(this.single, 'id', null),
        settings: {
          ...this.form,
        },
      };

      await this.saveGeoAnalysisSettings(data);

      await this.showNotify({ message: 'Данные сохранены' });

      this.isLoading = false;
    },
  },
};
</script>
